module.exports = __webpack_public_path__ + "static/media/Type_AC_first_floor.800969bd.jpg";